import "@/App.css";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App bg-[#0a0a0a] text-white min-h-screen">
      <Landing />
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
